import { apiFetch } from './client';

/**
 * The agents this instance is actually running.
 *
 * An agent id is **data**, never a literal. `MemoryPage` hardcoded
 * `'argv'`, was corrected to `'assistant'`, and both were wrong on
 * `wingd`, whose classes are `coordinator` and `technical-support` — the
 * same defect three times at three different spellings, each looking
 * repaired. ADR 030 D1 is explicit that an instance differs by name,
 * configuration and what it enables, so anything that names an agent has
 * to ask.
 */

export interface AgentRow {
  class_id: string;
  instance_id: string;
  suffix: string;
  status: string;
  uptime_s: number;
  model: string | null;
  channels: string[];
  channel_count: number;
  session_count: number;
  last_active_ms: number | null;
}

export function fetchAgents(): Promise<AgentRow[]> {
  return apiFetch<AgentRow[]>('/api/agents');
}

/**
 * The distinct agent *classes*, in the order the runtime reports them.
 *
 * `/api/memory/{id}` is keyed by class, not by instance — two instances
 * of one class share a memory (ADR 024: memory is agent-scoped). So a
 * chooser over instances would offer the same store twice.
 */
export function agentClasses(rows: AgentRow[]): string[] {
  return [...new Set(rows.map((r) => r.class_id))];
}
